export default "__VITE_ASSET__06be39cc__"